import React, { PropTypes } from 'react';
import CustomScroll from 'react-custom-scroll';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { icon } from './../icons/icons';

// actions
import * as actions from './../actions/actions';

// selectors
import { getPages } from '../selectors/selectors';

// components
import NavbarList from './../components/Navbar/NavbarList';

class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.addPage = this.addPage.bind(this);
    }

    addPage() {
        this.props.actions.addPage(this.props.pagesList);
    }

    render() {
        return (
            <div className="pages">
                <a title="Back" className="pages__back" href={(window.fos === undefined) ? '#' : Routing.generate('app_inquiry.get_all')}>
                    { icon.backArrow() }
                </a>
                <CustomScroll heightRelativeToParent="calc(100% - 75px)">
                    <NavbarList {...this.props} />
                </CustomScroll>
                <div className="pages__add" onClick={this.addPage}>
                    { icon.plus() } Add
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    pages: getPages(state.pages),
    pagesList: state.pages.list,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Navbar.propTypes = {
    pages: PropTypes.object.isRequired,
    pagesList: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/_app/quick_response/containers/Navbar.jsx